import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
const Layout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return <div className="flex h-screen bg-gray-100" data-id="element-76">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} data-id="element-77" />
      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-78">
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} data-id="element-79" />
        <main className="flex-1 overflow-y-auto p-4 bg-gray-50" data-id="element-80">
          <Outlet data-id="element-81" />
        </main>
      </div>
    </div>;
};
export default Layout;